import { render } from "./TripTMS.vue?vue&type=template&id=65a1d043&scoped=true&ts=true"
import script from "./TripTMS.vue?vue&type=script&lang=ts"
export * from "./TripTMS.vue?vue&type=script&lang=ts"

import "./TripTMS.vue?vue&type=style&index=0&id=65a1d043&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65a1d043"]])

export default __exports__